const React = require("react");

function MinusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 12H4"
  }));
}

module.exports = MinusIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/MinusIcon.js
 ** module id = 568
 ** module chunks = 0
 **/